import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import BaseWidgetProvider from '../base/BaseWidgetProvider'
import ExternalJobsWidget from './ExternalJobsWidget'

// Story 100 (S98, RN46/DN-16): registers the "External jobs" MOS widget -- the single surface where
// external (subcontracted) JOBs with a declared return deadline are dispatched and returned.
// Deliberately does NOT override getWidgetInfo's `availableWithoutDevice` (BaseWidgetProvider
// defaults it to false): the widget's list is installation-wide (DN-10/DN-13), but the widget itself
// still requires a device context to exist on screen -- it is never offered on the initial screen
// (no device associated), only on the screen of a device (any device, S99).
class ExternalJobsWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'ExternalJobsWidget'

  getName = () => 'External jobs'

  getIcon = () => LocalShippingOutlinedIcon

  createWidget = (props) => <ExternalJobsWidget {...props} />

  createPreviewWidget = (props) => <ExternalJobsWidget {...props} preview />

  size = { defaultW: 6, defaultH: 4, minW: 4, minH: 3 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }
}

export default ExternalJobsWidgetProvider
